import { useSelector } from 'react-redux';
import type { CurrencyCode } from '@noths/polaris-dev-ts-types';

import { selectSelectedOptionValues } from 'src/redux/basket/selectors';
import type { SelectedOptionValuesRecord } from 'src/redux/basket/types';
import { selectProduct } from 'src/redux/product/selectors';
import { selectUser } from 'src/redux/user/selectors';

/**
 * View model for the recommended-products carousels.
 *
 * Unlike the other slots, the products themselves are never in the store: they
 * come from a client-side listings request that the carousel makes through
 * useListingsRecommendations. So this supplies the store-derived inputs that
 * request is keyed on, plus the selected option values its click and impression
 * events carry, and the carousel keeps the fetch. That is enough for the
 * carousel to stop reading the store directly.
 */
export interface RecommendedProductsViewModel {
  currencyCode: CurrencyCode;
  partnerShortCode: string;
  productCode: string;
  selectedOptionValues: SelectedOptionValuesRecord;
  visitorId?: string;
}

export const useRecommendedProductsViewModel = (): RecommendedProductsViewModel => {
  const selectedOptionValues = useSelector(selectSelectedOptionValues);
  const { currencyCode, gaVisitorId: visitorId } = useSelector(selectUser);
  const product = useSelector(selectProduct);

  return {
    currencyCode,
    partnerShortCode: product.partner.shortcode,
    productCode: product.code.toString(),
    selectedOptionValues,
    visitorId,
  };
};
